import { Image } from "antd";
import { FC, useEffect, useMemo, useState } from "react";

interface IImage {
  imageUrl: string;
  [key: string]: string | number;
}

interface IProps {
  value: any;
  limit?: boolean | number;
}

const initArr = [{ imageUrl: '' }];
const img = "https://prodsuppart-s3.suppart.app/artworkCover/订单默认图片.jpg";

const ProductImg: FC<IProps> = ({ value, limit = false }) => {
  const [imgArr, setImgArr] = useState<IImage[]>([]);

  useEffect(() => {
    let images: IImage[] = [];
    try {
      if (!value) {
        images = initArr;
      } else {
        images = JSON.parse(value);
      }
    } catch (error) {
      console.log(error);
      images = initArr;
    }

    if (!limit) {
      setImgArr(images);
    } else if (typeof limit === 'number') {
      setImgArr(images.slice(0, limit));
    }
  }, [value, limit]);

  const imgUrl = useMemo(() => {
    if (!imgArr.length) return;
    return imgArr.slice(0, limit as number)?.imageUrl;
  }, [imgArr, limit]);

  return (
    <Image.PreviewGroup>
      {
        imgArr.map((image: IImage, index: number) => {
          return (
            <Image
              key={index}
              src={image.imageUrl}
              width={!limit ? 200 : 60}
              style={{ objectFit: 'cover', marginRight: 8 }}
              fallback={img}
            />
          )
        })
      }
    </Image.PreviewGroup>
  )
}

export default ProductImg;